import React, {useEffect} from 'react';

import {ErrorModalTemplate} from '../../../components/DataDisplay';
import pairingErrors from '../../../consts/device/pairingErrors';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import analyticsService from '../../../services/analyticsService';
import pairingService from '../../../services/pairingService';
import appRouterService from '../../../services/route/appRouterService';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import {pairingGuideErrorsContent} from './pairingGuideErrorsContent';

const PairingGuideErrorPopup = (props) => {
    const {deviceType, error, setError} = props;
    const {type} = error;
    const errorSet = getErrorSet(type, deviceType);

    useEffect(() => {
        analyticsService.pushFlowError(deviceType, type);
    }, [type]);

    if (!errorSet) return null;

    const {description, subDescription, mainButtonText, secondaryButtonText, title, accessibilityTitle} = errorSet;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDocumentTitle(accessibilityTitle);

    const onErrorPopupBtnClick = (isTryAgainBtn) => {
        setError(null);
        pairingService.disconnectAndClearState();
        appRouterService.forwardToConnectionFlowPage(deviceType, isTryAgainBtn);
    };

    const SubDescription = () => (
        <span className='cursor-pointer font-bold underline' onClick={appRouterService.forwardToContactUsPage}>
            {subDescription}
        </span>
    );

    return (
        <ErrorModalTemplate
            titleText={title}
            descriptionText={description}
            subDescription={<SubDescription />}
            buttonPrimary={{
                onClick: () => onErrorPopupBtnClick(true),
                testId: elementsTesIds.PAIRING_SEQUENCE_ERROR_TRY_AGAIN_BTN,
                text: mainButtonText,
            }}
            buttonSecondary={{
                ariaLabelKey: localizationKeys.DEVICE_PAIRING_ERROR_BTN_SKIP_ARIA_LABEL,
                onClick: () => onErrorPopupBtnClick(),
                testId: elementsTesIds.PAIRING_SEQUENCE_ERROR_SKIP_BTN,
                text: secondaryButtonText,
            }}
        />
    );
};

const getErrorSet = (type, deviceType) => {
    const {PAIRING_ERRORS, CONNECTION_ERRORS, DEVICE_SUPPORT_FAILED_ERRORS, WRONG_DEVICE_ERRORS} =
        pairingGuideErrorsContent(deviceType);

    switch (type) {
        case pairingErrors.ERROR_CONNECTION_NOT_FOUND.type:
            return CONNECTION_ERRORS;
        case pairingErrors.ERROR_PAIRING.type:
            return PAIRING_ERRORS;
        case pairingErrors.ERROR_NOT_SUPPORTED_DEVICE.type:
            return DEVICE_SUPPORT_FAILED_ERRORS;
        case pairingErrors.ERROR_WRONG_DEVICE.type:
            return WRONG_DEVICE_ERRORS;
        default:
            return null;
    }
};

export default PairingGuideErrorPopup;
